module.exports = __webpack_public_path__ + "img/img_jianjie.d9de9cff.jpg";